var map = {
	"./400x300x200-125F11.jfif": 234,
	"./kutii_gashi_drob1.jfif": 235,
	"./legen_40ltr_simo.jpg": 236,
	"./reshetka_boya.jpg": 237,
	"./vana_boya.jpg": 238
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 233;


//////////////////
// WEBPACK FOOTER
// ./src/images/sales nonrecursive \.(png|jpe?g|svg|jfif)$
// module id = 233
// module chunks = 0